import { useState } from 'react';
import { Box, Button, Paper, Stack, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { ory } from 'src/providers/authProvider';
import { Logger } from 'src/utils/Logger';

interface SuccessMessageProps {
  source: string | null;
}

export const SuccessMessage = ({ source }: SuccessMessageProps) => {
  const isRecoveryFlow = source === 'recovery';
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleGoToLogin = async () => {
    if (!isRecoveryFlow) return;

    setIsLoggingOut(true);
    try {
      const { data: logoutFlow } = await ory.createBrowserLogoutFlow();
      await ory.updateLogoutFlow({ token: logoutFlow.logout_token });
      window.location.href = '/login';
    } catch (error) {
      Logger.error('Failed to logout after password reset', error);
      window.location.href = '/login';
    }
  };

  return (
    <Paper bg="gray.0" radius="xl" py={48} px={48} w={450}>
      <Stack gap="md" align="center">
        <Box
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: 'var(--mantine-color-green-1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconCheck size={32} color="var(--mantine-color-green-6)" />
        </Box>

        <Text fz="xl" fw={600} ta="center">
          Settings updated
        </Text>

        {isRecoveryFlow ? (
          <>
            <Text size="sm" c="gray.6" ta="center">
              Your password has been updated successfully.
            </Text>
            <Button onClick={handleGoToLogin} mt="xs" fullWidth loading={isLoggingOut}>
              Go to Login
            </Button>
          </>
        ) : (
          <Text size="sm" c="gray.6" ta="center">
            Your changes have been saved. You can close this tab.
          </Text>
        )}
      </Stack>
    </Paper>
  );
};
